import { combineReducers } from 'redux';
import authReducer from './authReducer';
import dashboardReducer from './dashboardReducer';
import patientsReducer from './patientsReducer';
import bookingsReducer from './bookingReducer';

export default combineReducers({  
    authStore: authReducer,
    dashboardStore: dashboardReducer,
    patientsStore: patientsReducer,
    bookingStore: bookingsReducer
})